module.exports = __webpack_public_path__ + "assets/img/cf_1.6164e5bb.png";